/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import MarketingStore from '../MarketingStore';
import Footer from './Footer';
import Header from './Header/Header';
import * as styles from './Layout.module.css';

function htmlReplace(a, b, element) {
  if (!element) element = document.body;
  var nodes = element.childNodes;
  for (var n = 0; n < nodes.length; n++) {
    if (nodes[n].nodeType === Node.TEXT_NODE) {
      var r = new RegExp(a, 'gi');
      nodes[n].textContent = nodes[n].textContent.replace(r, b);
    } else {
      htmlReplace(a, b, nodes[n]);
    }
  }
}

const Layout = ({
  isBlog,
  isSpark = false,
  displayCta,
  hideNav = false,
  onCtaClick,
  children,
  background = '',
  className = '',
  pageMeta = null,
  footerClassName = '',
  noNav = false,
  smoothScroll = true,
}) => {
  const [importPolyfill, setImportPolyfill] = useState(false);

  // TODO uncomment after debugging https://app.asana.com/0/1186302909737103/1203009125265072/f
  // useEffect(() => {
  //   const supportsContainerQueries = 'container' in document.documentElement.style;
  //   if (!supportsContainerQueries) setImportPolyfill(true);
  // }, []);

  let bgColor;
  let isDark = false;
  switch (background) {
    case 'grey': {
      bgColor = styles.bgGrey;
      break;
    }
    case 'black': {
      bgColor = styles.bgBlack;
      isDark = true;
      break;
    }
    default: {
      bgColor = '';
      break;
    }
  }

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const [hashed, setHash] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && !hashed) {
      const { hash } = window.location;
      if (!hash) return;

      window.requestAnimationFrame(async () => {
        await setHash(true);
        const anchor = document.querySelector(hash);
        if (!anchor) return;
        const offset = anchor.getBoundingClientRect().top + window.scrollY - 84;

        window.scroll({ top: offset, left: 0, behavior: smoothScroll ? 'smooth' : 'auto' });
      });
    }
  }, [hashed]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    htmlReplace(/\u2028/g, '');
    const scripts = document.querySelectorAll('script[type="module"]');

    if (scripts) {
      for (const script of scripts) {
        script.setAttribute('data-ot-ignore', 'true');
      }
    }
  }, []);

  return (
    <div className={[className, styles.page, bgColor].join(' ')}>
      {importPolyfill && (
        <Helmet>
          <script src="https://unpkg.com/container-query-polyfill@0.2.4/dist/container-query-polyfill.modern.js" />
        </Helmet>
      )}
      <MarketingStore />
      {!noNav && (
        <Header
          className={'standard-header'}
          hideNav={hideNav}
          displayCta={displayCta}
          onCtaClick={onCtaClick}
          dark={isDark}
          isBlog={isBlog}
          isSpark={isSpark}
          siteTitle={data.site.siteMetadata.title}
          pageMeta={pageMeta}
        />
      )}
      <div>
        <main>{children}</main>
      </div>
      <Footer isSpark={isSpark} dark={isDark} className={footerClassName} />
    </div>
  );
};

export const BACKGROUND = {
  WHITE: 'white',
  GREY: 'grey',
  BLACK: 'black',
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  background: PropTypes.oneOf([BACKGROUND.GREY, BACKGROUND.WHITE]),
};

export default Layout;
